import { render, staticRenderFns } from "./ConfigCoach.vue?vue&type=template&id=6e88a4e6"
import script from "./ConfigCoach.vue?vue&type=script&lang=js"
export * from "./ConfigCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports